import { useEffect, useState } from "react";
import { ScrollText, CheckCircle2, ChevronDown, ChevronUp } from "lucide-react";
import { http, formatApiError } from "../../lib/api";

// Consignes permanentes des sites de l'agent : rappel non bloquant + confirmation de lecture
export function AgentInstructions() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const [err, setErr] = useState("");
  const load = () => http.get("/agent-app/instructions").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const vis = () => document.visibilityState === "visible" && load();
    document.addEventListener("visibilitychange", vis);
    const iv = setInterval(load, 120000);
    return () => { document.removeEventListener("visibilitychange", vis); clearInterval(iv); };
  }, []);
  const ack = async (id) => {
    try { await http.post(`/agent-app/instructions/${id}/ack`); setOpen(null); load(); } catch (e) { setErr(formatApiError(e)); }
  };
  if (!items.length) return null;
  const todo = items.filter((i) => !i.acked).length;
  return (
    <section data-testid="agent-instructions">
      {todo > 0 && <div data-testid="instructions-banner" className="mb-2 rounded-xl border-2 border-amber-400 bg-amber-50 px-4 py-3 text-sm font-bold text-amber-900">{todo} consigne{todo > 1 ? "s" : ""} du site à lire et confirmer</div>}
      <h2 className="font-display text-lg font-extrabold mb-2 text-[#0B2A7A]">Consignes du site</h2>
      {err && <div className="text-sm text-rose-700 mb-2">{err}</div>}
      <div className="space-y-2">
        {items.map((i) => (
          <div key={i.id} className={`bg-white border rounded-xl overflow-hidden ${i.acked ? "border-slate-200" : "border-amber-300"}`} data-testid={`instruction-${i.id}`}>
            <button onClick={() => setOpen(open === i.id ? null : i.id)} className="w-full text-left px-4 py-3 flex items-center gap-3">
              {i.acked ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0" /> : <ScrollText className="h-5 w-5 text-amber-600 shrink-0" />}
              <div className="flex-1 min-w-0"><div className="font-semibold text-sm truncate">{i.title}</div><div className="text-xs text-slate-500">{i.site_name}{i.acked ? " · lue" : " · à lire"}</div></div>
              {open === i.id ? <ChevronUp className="h-4 w-4 text-slate-400" /> : <ChevronDown className="h-4 w-4 text-slate-400" />}
            </button>
            {open === i.id && (
              <div className="px-4 pb-4 border-t border-slate-100 pt-3 space-y-3">
                <div className="text-sm text-slate-700 whitespace-pre-line">{i.body}</div>
                {!i.acked && <button data-testid={`instruction-ack-${i.id}`} onClick={() => ack(i.id)} className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold rounded-lg py-2.5 transition-colors">J&apos;ai lu et compris</button>}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
